import { observer } from "mobx-react-lite";
import { useSearchParams } from "react-router-dom";
import { motion } from "motion/react";
import { FC } from "react";
import styled from "@emotion/styled";
import { OAuthConsentPageContent } from "@/pages/oauth-consent/oauth-consent-page-content";

export const OAuthConsentPage: FC = observer(() => {
  const [search] = useSearchParams();

  const redirectUri = search.get("redirect_uri") ?? "";
  const clientId = search.get("client_id") ?? "";
  const state = search.get("state") ?? "";
  const scopeStr = search.get("scope") ?? "";
  const responseType = search.get("response_type") ?? "";

  return (
    <PageWrapper>
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.1 }}>
        <OAuthConsentPageContent
          redirectUri={redirectUri}
          clientId={clientId}
          state={state}
          scopeStr={scopeStr}
          responseType={responseType}
        />
      </motion.div>
    </PageWrapper>
  );
});

const PageWrapper = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  webkitappregion: drag;
  z-index: 9999;
  background: ${({ theme }) => theme.colors.white};
`;
